const GENERATED_AVATAR_MARKER = "cvcanvas-generated-avatar";

function hashString(value = "") {
  return Array.from(value).reduce(
    (sum, character) => sum + character.charCodeAt(0),
    0,
  );
}

export function getResumeInitials(name = "") {
  const parts = String(name)
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length === 0) return "CV";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();

  return `${parts[0][0] || ""}${parts[parts.length - 1][0] || ""}`.toUpperCase();
}

function getAvatarColors(name = "") {
  const palette = [
    { background: "#1d4ed8", foreground: "#eff6ff" },
    { background: "#0f766e", foreground: "#ecfeff" },
    { background: "#7c3aed", foreground: "#f5f3ff" },
    { background: "#be123c", foreground: "#fff1f2" },
    { background: "#c2410c", foreground: "#fff7ed" },
    { background: "#334155", foreground: "#f8fafc" },
  ];

  return palette[hashString(name) % palette.length];
}

export function createGeneratedResumeAvatar(name = "") {
  const initials = getResumeInitials(name);
  const { background, foreground } = getAvatarColors(name);

  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="256" height="256" viewBox="0 0 256 256">
      <title>${GENERATED_AVATAR_MARKER}</title>
      <rect width="256" height="256" rx="128" fill="${background}" />
      <text
        x="50%"
        y="54%"
        text-anchor="middle"
        dominant-baseline="middle"
        font-family="Arial, Helvetica, sans-serif"
        font-size="96"
        font-weight="700"
        fill="${foreground}"
      >
        ${initials}
      </text>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg.trim())}`;
}

export function isGeneratedResumeAvatar(value = "") {
  if (typeof value !== "string" || !value.startsWith("data:image/svg+xml")) {
    return false;
  }

  try {
    return decodeURIComponent(value).includes(GENERATED_AVATAR_MARKER);
  } catch (error) {
    return false;
  }
}
